// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"370":"64a809a7","489":"f982a9c7","518":"9a07be80","668":"c6918fb5","706":"0f472188","852":"ba231f6a"}[chunkId] + ".css";
};